import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { Breadcrumbs } from "../../_PageLayout/components/Connected";
import { HeadingBanner } from "./components/HeadingBanner";
import { getHeadingTitle } from "../../store/blocks/heading/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var HeadingComponent = function HeadingComponent(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-HeadingBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('breadcrumbs')
  }, /*#__PURE__*/React.createElement(Breadcrumbs, null)), /*#__PURE__*/React.createElement(HeadingBanner, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: getHeadingTitle(state)
  };
};
export var HeadingBlock = compose(connect(mapStateToProps), defineBlock(FttbBlocks.HEADING), withRenderFlag)(HeadingComponent);